import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ LIST ATTRIBUTE GROUPS FOR A COMPANY
 * Returns one row per group member (LEFT JOIN) — group with no members
 * still returns one row with null member/attribute columns.
 * Targets: DeclrAttributeGroupController.list (Corp.usp_Z_11_Declr_AttributeGroup_List)
 */
export const fetchAttributeGroups = async (corporateEntityId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-group/list",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Declr Attribute Group List Failed:", err);
        return [];
    }
};

/**
 * 🛰️ ADD ATTRIBUTE GROUP
 * Targets: DeclrAttributeGroupController.add (Corp.usp_Z_11_Declr_AttributeGroup_Add)
 */
export const addAttributeGroup = async (corporateEntityId, groupLabel, sortOrder, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-group/add",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId, GroupLabel: groupLabel, SortOrder: sortOrder || 0 })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not create attribute group.");
        return res.data;
    } catch (err) {
        console.error("Declr Attribute Group Add Error:", err);
        throw err;
    }
};

/**
 * 🛰️ REMOVE ATTRIBUTE GROUP
 * Targets: DeclrAttributeGroupController.remove (Corp.usp_Z_11_Declr_AttributeGroup_Remove)
 */
export const removeAttributeGroup = async (attributeGroupId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-group/remove",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ AttributeGroupId: attributeGroupId })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not remove attribute group.");
        return true;
    } catch (err) {
        console.error("Declr Attribute Group Remove Error:", err);
        throw err;
    }
};

/**
 * 🛰️ ADD / REMOVE A MEMBER ATTRIBUTE
 * Targets: DeclrAttributeGroupController.[AddMember|RemoveMember]
 */
export const addAttributeGroupMember = async (attributeGroupId, attributeDefinitionId, sortOrder, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-group/member/add",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ AttributeGroupId: attributeGroupId, AttributeDefinitionId: attributeDefinitionId, SortOrder: sortOrder || 0 })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not add attribute to group.");
        return true;
    } catch (err) {
        console.error("Declr Attribute Group Member Add Error:", err);
        throw err;
    }
};

export const removeAttributeGroupMember = async (attributeGroupMemberId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-group/member/remove",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ AttributeGroupMemberId: attributeGroupMemberId })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not remove attribute from group.");
        return true;
    } catch (err) {
        console.error("Declr Attribute Group Member Remove Error:", err);
        throw err;
    }
};
